import React from "react";
import { Box, makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flex: 1,
    height: "max-content",
    minHeight: "80vh",
  },
}));
function Page(props) {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      justifyContent="center"
      className={classes.container}
      {...props}
    >
      {props.children}
    </Box>
  );
}

export default Page;
